import { useState } from "react";
import { IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";

export type Option = {
  label: string;
  value: string;
  onClick: () => void;
  disabled: boolean;
  icon?: React.ReactNode;
  tooltip?: string;
};

type ReferenceDropdownMenuProps = {
  options: Option[];
};

export function ReferenceDropdownMenu(props: ReferenceDropdownMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.preventDefault();
    setAnchorEl(null);
  };

  return (
    <div style={{ marginLeft: "auto" }} onClick={(e) => e.stopPropagation()}>
      <IconButton size={"small"} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {props.options.map((option) => (
          <Tooltip title={option.tooltip ?? ""} key={option.value}>
            <li>
              <MenuItem
                onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                  option.onClick();
                  handleClose(e);
                }}
                component="span"
                disabled={option.disabled}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                {option.label}
                {option.icon && option.icon}
              </MenuItem>
            </li>
          </Tooltip>
        ))}
      </Menu>
    </div>
  );
}
